import script from "./FooterOrganism.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterOrganism.vue?vue&type=script&setup=true&lang=js"

import "./FooterOrganism.vue?vue&type=style&index=0&id=c9fe84be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9fe84be"]])

export default __exports__